<template>
	<v-overlay
			:value="value"
			z-index="9999"
			:opacity="$vuetify.theme.dark ? 0.72 : 0.58"
	>
		<div
				class="bank-sync-loader"
				:class="{
        'bank-sync-loader--dark': $vuetify.theme.dark,
        'bank-sync-loader--light': !$vuetify.theme.dark,
      }"
				:style="{
        '--bank-sync-accent': $vuetify.theme.currentTheme.success || '#4caf50',
      }"
				role="status"
				aria-live="polite"
				aria-busy="true"
		>
			<div class="bank-sync-loader__network">
				<div class="bank-sync-loader__node">
					<div class="bank-sync-loader__icon">
						<v-icon>
							mdi-bank
						</v-icon>
					</div>

					<span class="bank-sync-loader__node-name">
            Bank
          </span>
				</div>

				<div class="bank-sync-loader__connection">
					<span class="bank-sync-loader__line"></span>

					<span
							class="
              bank-sync-loader__packet
              bank-sync-loader__packet--1
            "
					></span>

					<span
							class="
              bank-sync-loader__packet
              bank-sync-loader__packet--2
            "
					></span>

					<span
							class="
              bank-sync-loader__packet
              bank-sync-loader__packet--3
            "
					></span>
				</div>

				<div class="bank-sync-loader__node">
					<div class="bank-sync-loader__icon">
						<v-icon>
							mdi-server
						</v-icon>
					</div>

					<span class="bank-sync-loader__node-name">
            Server
          </span>
				</div>

				<div class="bank-sync-loader__connection">
					<span class="bank-sync-loader__line"></span>

					<span
							class="
              bank-sync-loader__packet
              bank-sync-loader__packet--1
            "
					></span>

					<span
							class="
              bank-sync-loader__packet
              bank-sync-loader__packet--2
            "
					></span>

					<span
							class="
              bank-sync-loader__packet
              bank-sync-loader__packet--3
            "
					></span>
				</div>

				<div class="bank-sync-loader__node">
					<div class="bank-sync-loader__icon">
						<v-icon>
							mdi-database
						</v-icon>
					</div>

					<span class="bank-sync-loader__node-name">
            Fleet
          </span>
				</div>
			</div>

			<div class="bank-sync-loader__content">
				<div class="bank-sync-loader__title">
					Updating transactions
				</div>

				<div class="bank-sync-loader__text">
					{{ text }}
				</div>

				<div class="bank-sync-loader__activity">
					<span></span>
					<span></span>
					<span></span>
				</div>
			</div>
		</div>
	</v-overlay>
</template>

<script>
export default {
	name: "BankSyncLoader",

	props: {
		value: {
			type: Boolean,
			default: false,
		},

		text: {
			type: String,
			default: "Receiving latest data from the bank...",
		},
	},
};
</script>

<style lang="scss" scoped>
.bank-sync-loader {
	--bank-sync-accent: #4caf50;
	--bank-sync-background: #ffffff;
	--bank-sync-border: rgba(25, 30, 35, 0.09);
	--bank-sync-title: #24272a;
	--bank-sync-text: #777d82;
	--bank-sync-node-text: #71777c;
	--bank-sync-node-background: rgba(76, 175, 80, 0.07);
	--bank-sync-node-border: rgba(76, 175, 80, 0.28);
	--bank-sync-line: rgba(65, 75, 83, 0.14);
	--bank-sync-shadow: rgba(15, 23, 31, 0.18);

	position: relative;

	width: 540px;
	max-width: calc(100vw - 32px);

	overflow: hidden;

	padding: 32px 38px 28px;

	border: 1px solid var(--bank-sync-border);
	border-radius: 8px;

	background: var(--bank-sync-background);
	color: var(--bank-sync-title);

	text-align: center;

	box-shadow: 0 22px 60px var(--bank-sync-shadow);

	&::before {
		content: "";

		position: absolute;

		top: 0;
		left: -40%;

		width: 38%;
		height: 1px;

		background: linear-gradient(
				90deg,
				transparent,
				var(--bank-sync-accent),
				transparent
		);

		opacity: 0.85;

		animation: bankSyncTopLine 2.4s linear infinite;
	}

	&--dark {
		--bank-sync-background: #242426;
		--bank-sync-border: rgba(255, 255, 255, 0.08);
		--bank-sync-title: rgba(255, 255, 255, 0.94);
		--bank-sync-text: rgba(255, 255, 255, 0.5);
		--bank-sync-node-text: rgba(255, 255, 255, 0.52);
		--bank-sync-node-background: rgba(76, 175, 80, 0.07);
		--bank-sync-node-border: rgba(76, 175, 80, 0.33);
		--bank-sync-line: rgba(255, 255, 255, 0.12);
		--bank-sync-shadow: rgba(0, 0, 0, 0.45);
	}

	&--light {
		--bank-sync-background: #ffffff;
		--bank-sync-border: rgba(25, 30, 35, 0.09);
		--bank-sync-title: #24272a;
		--bank-sync-text: #777d82;
		--bank-sync-node-text: #71777c;
		--bank-sync-node-background: rgba(76, 175, 80, 0.06);
		--bank-sync-node-border: rgba(76, 175, 80, 0.25);
		--bank-sync-line: rgba(65, 75, 83, 0.14);
		--bank-sync-shadow: rgba(15, 23, 31, 0.18);
	}

	&__network {
		display: flex;
		align-items: flex-start;
		justify-content: center;

		margin-bottom: 28px;
	}

	&__node {
		position: relative;
		z-index: 2;

		display: flex;
		flex: 0 0 70px;
		flex-direction: column;
		align-items: center;
	}

	&__icon {
		position: relative;

		display: flex;
		align-items: center;
		justify-content: center;

		width: 46px;
		height: 46px;

		border: 1px solid var(--bank-sync-node-border);
		border-radius: 50%;

		background: var(--bank-sync-node-background);

		animation: bankSyncNodePulse 2.4s ease-in-out infinite;

		&::after {
			content: "";

			position: absolute;

			inset: -5px;

			border: 1px solid var(--bank-sync-node-border);
			border-radius: 50%;

			opacity: 0;

			animation: bankSyncNodeRing 2.4s ease-out infinite;
		}

		.v-icon {
			color: var(--bank-sync-accent);

			font-size: 21px;
		}
	}

	&__node-name {
		margin-top: 9px;

		color: var(--bank-sync-node-text);

		font-size: 11px;
		font-weight: 500;
		letter-spacing: 0.3px;
	}

	&__connection {
		position: relative;

		flex: 0 0 110px;

		height: 46px;

		margin: 0 4px;
	}

	&__line {
		position: absolute;

		top: 22px;
		left: 0;

		width: 100%;
		height: 1px;

		overflow: hidden;

		background: var(--bank-sync-line);

		&::after {
			content: "";

			position: absolute;

			top: 0;
			left: -55%;

			width: 50%;
			height: 100%;

			background: linear-gradient(
					90deg,
					transparent,
					var(--bank-sync-accent),
					transparent
			);

			animation: bankSyncLine 1.65s linear infinite;
		}
	}

	&__packet {
		position: absolute;

		top: 19px;
		left: 0;

		width: 7px;
		height: 7px;

		border-radius: 2px;

		background: var(--bank-sync-accent);

		opacity: 0;

		box-shadow: 0 0 8px rgba(76, 175, 80, 0.58);

		animation: bankSyncPacket 1.65s linear infinite;

		&--2 {
			animation-delay: 0.55s;
		}

		&--3 {
			animation-delay: 1.1s;
		}
	}

	&__content {
		position: relative;
	}

	&__title {
		margin-bottom: 7px;

		color: var(--bank-sync-title);

		font-size: 17px;
		font-weight: 600;
		line-height: 1.35;
	}

	&__text {
		min-height: 20px;

		color: var(--bank-sync-text);

		font-size: 13px;
		font-weight: 400;
		line-height: 1.45;
	}

	&__activity {
		display: flex;
		align-items: center;
		justify-content: center;

		min-height: 6px;

		margin-top: 14px;

		gap: 5px;

		span {
			width: 4px;
			height: 4px;

			border-radius: 50%;

			background: var(--bank-sync-accent);

			opacity: 0.22;

			animation: bankSyncActivity 1.3s ease-in-out infinite;

			&:nth-child(2) {
				animation-delay: 0.18s;
			}

			&:nth-child(3) {
				animation-delay: 0.36s;
			}
		}
	}

	@media (max-width: 767px) {
		width: calc(100vw - 24px);
		max-width: none;

		padding: 27px 16px 24px;

		&__network {
			margin-bottom: 24px;
		}

		&__node {
			flex-basis: 56px;
		}

		&__icon {
			width: 40px;
			height: 40px;

			.v-icon {
				font-size: 19px;
			}
		}

		&__connection {
			flex-basis: 58px;

			height: 40px;
		}

		&__line {
			top: 19px;
		}

		&__packet {
			top: 16px;
		}

		&__node-name {
			margin-top: 8px;

			font-size: 10px;
		}

		&__title {
			font-size: 16px;
		}

		&__text {
			font-size: 12px;
		}
	}

	@media (max-width: 400px) {
		padding-right: 12px;
		padding-left: 12px;

		&__node {
			flex-basis: 52px;
		}

		&__connection {
			flex-basis: 44px;

			margin-right: 2px;
			margin-left: 2px;
		}
	}
}

@keyframes bankSyncPacket {
	0% {
		left: 0;

		opacity: 0;

		transform: scale(0.65);
	}

	12% {
		opacity: 1;
	}

	86% {
		opacity: 1;
	}

	100% {
		left: calc(100% - 7px);

		opacity: 0;

		transform: scale(1);
	}
}

@keyframes bankSyncLine {
	from {
		left: -55%;
	}

	to {
		left: 105%;
	}
}

@keyframes bankSyncNodePulse {
	0%,
	100% {
		border-color: var(--bank-sync-node-border);

		transform: scale(1);
	}

	50% {
		border-color: var(--bank-sync-accent);

		transform: scale(1.04);
	}
}

@keyframes bankSyncNodeRing {
	0%,
	45% {
		opacity: 0;

		transform: scale(0.9);
	}

	60% {
		opacity: 0.28;
	}

	100% {
		opacity: 0;

		transform: scale(1.12);
	}
}

@keyframes bankSyncTopLine {
	from {
		left: -40%;
	}

	to {
		left: 105%;
	}
}

@keyframes bankSyncActivity {
	0%,
	100% {
		opacity: 0.2;

		transform: translateY(0);
	}

	50% {
		opacity: 1;

		transform: translateY(-2px);
	}
}

@media (prefers-reduced-motion: reduce) {
	.bank-sync-loader {
		&::before,
		&__icon,
		&__icon::after,
		&__line::after,
		&__packet,
		&__activity span {
			animation: none;
		}

		&__packet {
			opacity: 0.75;
		}
	}
}
</style>
